<template>
  <div class="web-box-all">
    <ext-header select_menu="9"></ext-header>

    <div class="web-home-main">

      <div class="web-order-box">
        <div class="web-order-left">
          <ext-nav></ext-nav>
        </div>
        <div class="web-order-right">
          <div class="web-user-title">
            <p><i></i>我的弗兰卡 > 我的评价</p>
          </div>

          <ext-loading v-if="list_data.length==0" style="width:100%;" title="当前没有消息"></ext-loading>

          <div class="web-order-list-box">

            <div class="web-order-list-data" v-for="(vo,index) in list_data" :key="index">
              <div class="web-order-list-title">
                <h2>{{vo.store_name}}</h2>
                <p>
                  <img :src="[ vo.evaluate_level>=1 ? xx_ok : xx_no ]"/>
                  <img :src="[ vo.evaluate_level>=2 ? xx_ok : xx_no ]"/>
                  <img :src="[ vo.evaluate_level>=3 ? xx_ok : xx_no ]"/>
                  <img :src="[ vo.evaluate_level>=4 ? xx_ok : xx_no ]"/>
                  <img :src="[ vo.evaluate_level==5 ? xx_ok : xx_no ]"/>
                  <span>{{vo.ctime}}</span>
                </p>
              </div>
              <div class="web-order-list-goods">
                <ul>
                  <li>
                    <img @click="get_goods_show(vo.goods_no)" src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
                    <p>
                      <a>{{vo.goods_name}}</a>
                      <b>{{vo.goods_no}}</b>
                    </p>
                  </li>
                </ul>
              </div>
              <div class="web-order-list-money" style="display:none">
                <img src="https://parts.franke.cn/Gallery/goods/63015218/thumbnail_63015218_1.png"/>
              </div>
              <div class="web-order-list-auto">
                <p>{{vo.evaluate_remark}}</p>
              </div>
            </div>

          </div>

          <div class="web-order-list-page">
            <b-pagination
              v-model="currentPage"
              :total-rows="list_count"
              :per-page="perPage"
              @change="load_page"
              first-number
              last-number
            >
            <template #prev-text><span class="lemon-page">上一页</span></template>
            <template #next-text><span class="lemon-page">下一页</span></template>
            <template #page="{ page, active }">
              <b class="lemon-page-now" v-if="active">{{ page }}</b>
              <i class="lemon-page-line" v-else>{{ page }}</i>
            </template>
            </b-pagination>
          </div>

        </div>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtNav from '@/components/leftnav/index'
import ExtLoading from '@/components/loading/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'

export default {
  name: 'evaluate',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-nav': ExtNav,
    'ext-loading': ExtLoading
  },
  data () {
    return {
      title: '订单列表',
      web_url: webUrl(),
      xx_ok: require('@/assets/icon/xx_1.png'),
      xx_no: require('@/assets/icon/xx_2.png'),
      perPage: 10,
      currentPage: 1,
      list_data: [],
      list_count: 0
    }
  },
  mounted () {
    this.load_data()
  },
  methods: {
    get_goods_show (goodsNo) {
      this.$router.push({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
    },
    load_page (page) {
      this.currentPage = page
      this.load_data()
    },
    load_data () {
      var that = this
      var page = this.currentPage
      ajax({
        url: '/store/user/user_goods_evealuate',
        method: 'post',
        data: {
          uid: getUserId(),
          page: page
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.list_count = ret.data.list_count
          that.list_data = ret.data.list_data
        } else {
          that.list_data = []
          that.list_count = 0
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
  .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}

  .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-user-title { width:100%; height:40px;flex-flow:row; align-content:flex-start;}
      .web-user-title p { width:auto; height:40px; position: relative; padding:0px 20px; line-height:40px; font-size:14px; color:#333333;}
      .web-user-title p i { width:2px; height:20px; float: left; background: #d81e06; position: absolute; top:10px; left:10px;}

.web-order-list-box { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-order-list-data { width:100%; height:auto; border:1px solid #dfdfdf; margin-top:15px; flex-wrap:wrap; align-content:flex-start;}
      .web-order-list-title { width:100%; height:40px; padding:0px 15px; background: #f5f5f5; flex-flow:row; justify-content:space-between;}
      .web-order-list-title h2 { width:auto; height:40px; line-height:40px; font-size:12px; color:#333333;}
      .web-order-list-title h2 span { width:auto; height:40px; line-height:40px; margin-left:20px; font-size:12px; color:#aaaaaa;}
      .web-order-list-title p { width:auto; height:40px; line-height:40px; cursor: pointer; font-size:12px; color:#333333;}
      .web-order-list-title p img { width:16px; height:16px; margin:12px 5px 0px 0px;}
      .web-order-list-title p span { width:auto; height:40px; line-height:40px; font-size:12px; color:#aaaaaa; flex-flow:row; justify-content:flex-start;;}
      .web-order-list-goods { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start; }
      .web-order-list-goods ul { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start; list-style:none; margin:0px; padding:0px;}
      .web-order-list-goods ul li { width:100%; height:90px; flex-flow:row; justify-content:flex-start; margin:0px; padding:15px; border-bottom: 1px solid #dfdfdf;}
      .web-order-list-goods ul li img { width:60px; height:60px; margin-right:20px; cursor: pointer;}
      .web-order-list-goods ul li p { width:520px; height:60px;  flex-wrap:wrap; align-content:flex-start;}
      .web-order-list-goods ul li p a { width:100%; height:40px; line-height:20px; font-size:12px; color:#333333;}
      .web-order-list-goods ul li p a:hover { color:#333333;}
      .web-order-list-goods ul li p b { width:100%; height:20px; font-weight: normal; line-height:20px; font-size:12px; color:#aaaaaa;}
      .web-order-list-goods ul li h2 { width:150px; height:60px;  flex-wrap:wrap; align-content:flex-start;}
      .web-order-list-goods ul li h2 a { width:100%; height:20px; line-height:20px; font-size:12px; color:#333333; text-align: right; justify-content:flex-end; }
      .web-order-list-goods ul li h2 a:hover { color:#333333;}
      .web-order-list-money { width:100%; height:auto; flex-flow:row; padding:0px 15px; justify-content:flex-start;}
      .web-order-list-money img { width:100px; height:100px;  margin-top:10px; color:#d81e06}
      .web-order-list-auto { width:100%; height:auto;  flex-flow:row;justify-content:flex-end; padding:0px 15px;  }
      .web-order-list-auto p { width:100%; height:auto; font-size:12px; line-height:20px; margin-top:5px; }
    .web-order-list-page { width:100%; height:40px; margin-top:20px;}

    .lemon-page { color:#333333; font-size:12px; height:24px; line-height:24px;}
    .lemon-page-now { background: #d81e06 !important; color:#ffffff !important; width:24px; height:24px;}
    .lemon-page-line { color:#333333; font-style: normal;}
</style>
<style>
  .page-item.active .page-link { border:1px solid #d81e06;background: #d81e06 !important; color:#ffffff !important;}
</style>



// WEBPACK FOOTER //
// src/pages/store/evaluate.vue